import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { FileInfo } from "../models/file";



@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient) {}

  listDocuments(storageLocation: string): Observable<FileInfo[]> {
    const params = { storageLocation };
    return this.http.get<FileInfo[]>(`${environment.apiUrl}/files`, { params });
  }
  downloadDocument(link: string): Observable<Blob> {
    const decodedLink = encodeURIComponent(link);
    return this.http.get(`${environment.apiUrl}/files/${decodedLink}`, {
      responseType: 'blob'
    });
  }

  deleteDocument(link: string): Observable<void> {
    const decodedLink = encodeURIComponent(link);
    return this.http.delete<void>(`${environment.apiUrl}/files/${decodedLink}`);
  }

  uploadDocument(file: File, storageLocation: string): Observable<{ link: string }> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("storageLocation", storageLocation);

    return this.http.post<{ link: string }>(`${environment.apiUrl}/files`, formData);
  }
}